import { Restaurant, DirectionsWalk, Attractions, Museum, LocalBar, ShoppingCart } from "@mui/icons-material";

const iconMapping = {
  "Breakfast": <Restaurant />,
  "Lunch": <Restaurant />,
  "Dining Experience": <Restaurant />,
  "Morning Walk": <DirectionsWalk />,
  "Sightseeing": <Attractions />,
  "Museum Visit": <Museum />,
  "Bars & Nightlife": <LocalBar />,
  "Shopping": <ShoppingCart />,
};

export default iconMapping;
